import { Layout, Space } from 'antd'
import PayItemSelect from 'components/CIMSSelect/common/PayItemSelect'
import { useSummaryContext } from '../SummaryContext'
import EditOrderModal from '../../EditOrderModal'
import CopyPasteIcon from 'components/CopyPasteIcon'

const Header: React.FC = () => {
  const { setGlobalId, globalId, copied } = useSummaryContext()
  return (
    <>
      <Layout.Header
        style={{ padding: 0, height: 'unset', backgroundColor: 'unset' }}
      >
        <Space size="large" align="center">
          <CopyPasteIcon
            copyable={globalId ? copied : undefined}
            tooltip="Copy Pay Item ID - Description to clipboard"
          >
            <PayItemSelect
              showLabel
              simple
              value={globalId}
              style={{ width: 'max(25vw, 300px)' }}
              onChange={(value) => setGlobalId(value as string)}
            />
          </CopyPasteIcon>
          <EditOrderModal />
        </Space>
      </Layout.Header>
    </>
  )
}

export default Header
